import { DeleteRowOutlined } from "@ant-design/icons";
import { blacklistAuthScope, CrudOp } from "@org-avp/avp-avengers-ui-shared-auth";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { BlacklistView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator, { project }) => {
  const authHelper = authHelperCreator(blacklistAuthScope);
  return project != null && authHelper.evaluate(CrudOp.READ, project);
};

export const blacklistViewKey = "project_modular_blacklist/:projectId/:subprojectId/:brand/:modelYear/:mbvKeys";
export const blacklistViewModule: ViewModule = {
  viewKey: blacklistViewKey,
  viewEl: <BlacklistView/>,
  displayNameI18nKey: "blacklist:viewName",
  menuIconEl: <DeleteRowOutlined/>,
  isAuthorized,
  translations,
};
